var _ = require('underscore');
var $ = require('jquery');
var TorsoView = require('backbone-torso/modules/View');
var formWidgetTemplate = require('./appointmentFormWidgetTemplate.hbs');
var formExtService = require('./../urls').formExtService;
var PdfViewerWidget = require('./../widget/pdf-viewer/PdfViewerWidget');
var WizardWidget = require('./../wizard/WizardWidget');
var UseModalBehavior = require('./../widget/modal/UseModalBehavior');
var ModalDialogWidget = require('./../widget/modal/ModalDialogWidget');
var FormDataBehavior = require('./../form/FormDataBehavior');
var stringUtils = require('./../utils/stringUtils');

module.exports = TorsoView.extend({
  template: formWidgetTemplate,

  prepareFields: [ 'patientVecnaId', 'appointmentExternalId', 'formName'],

  behaviors: {
    useModalBehavior: {
      behavior: UseModalBehavior
    },
    form: {
      behavior: FormDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      alwaysFetch: true,
      id: { property: 'formName'}
    }
  },

  injectionSites: {
    'pdf-viewer': '_pdfViewerWidget'
  },

  /**
   * @method initialize
   * @param options {Object}
   *   @param options.patientVecnaId {String} the patient id of the patient to get the form for.
   *   @param options.appointmentExternalId {String} the external id of the appointment to get the form for.
   *   @param options.formName {String} the name of the form to display.
   * @override
   */
  initialize: function(options) {
    _.bindAll(this, 'render', '_setSaveComplete', '_setSaveFailed', '_setSaveSuccess', '_navigateToNextStep', '_declineFormAndNavigateToNextStep');

    _.extend(this, _.pick(options, ['patientVecnaId', 'appointmentExternalId', 'formName']));

    this._pdfViewerWidget = new PdfViewerWidget({pdfUrl : formExtService + '/' + this.formName + '/pdf'});

    var declineText = this._getDeclineText();

    this._modalDialogWidget = new ModalDialogWidget({
      dataViewName: 'confirm decline form',
      description: declineText,
      yesKey: 'appointmentForm.decline.modal.yes',
      noKey: 'appointmentForm.decline.modal.no'
    });
  },

  /**
   * @method _attached
   * @private
   */
  _attached: function() {
    this.listenTo(this._getWizardWidget(), 'sign-form', this._signFormAndNavigateToNextStep);
  },

  /**
   * Do some cleanup when the view is detached.
   * @method _detached
   * @private
   * @override
   */
  _detached: function() {
    this.stopListening(this._getWizardWidget(), 'sign-form', this._signFormAndNavigateToNextStep);
  },

 /**
   * Gets the wizard widget for the patient and appointment.
   * @method _getWizardWidget
   * @return {WizardWidget} the wizard widget for the patient and appointment.
   * @private
   */
  _getWizardWidget: function() {
    return WizardWidget.getWizardWidget({
      patientVecnaId: this.patientVecnaId,
      appointmentExternalId: this.appointmentExternalId
    });
  },

  /**
   * Submit form and navigates to the next step.
   * @method _signFormAndNavigateToNextStep
   * @private
   */
  _signFormAndNavigateToNextStep: function(agreed) {
    if (agreed) {
      this._saveFormModel(agreed);
    } else {
      this._showConfirmDeclineModal();
    }
  },

  /**
   * Decline form and navigates to the next step
   * @method _declineFormAndNavigateToNextStep
   * @private
   */
  _declineFormAndNavigateToNextStep: function() {
    this._saveFormModel(false);
  },

  /**
   * @method showConfirmDeclineModal
   * @private
   */
  _showConfirmDeclineModal: function() {
    this.showModal(this._modalDialogWidget, this._declineFormAndNavigateToNextStep);
  },

  /**
   * @method _saveFormModel
   * @param agreed {Boolean} true if signing the form, false if declining the form
   * @private
   */
  _saveFormModel: function(agreed) {
    var formModel = this.getBehavior('form').data.getModel();
    formModel.set('agreed', agreed);
    formModel.set('extAppointmentId', this.appointmentExternalId);
    this.set('saveInProgress', true);
    formModel.save()
      .then(this._setSaveSuccess, this._setSaveFailed)
      .then(this._navigateToNextStep, this._setSaveComplete);
  },

  /**
   * Convenience method for promises that want to mark the saving process as completed.
   * @method _setSaveComplete
   * @private
   */
  _setSaveComplete: function() {
    this.set('saveInProgress', false);
  },

  /**
   * Convenience method for promises that want to mark the saving process as failed.
   * @method _setSaveFailed
   * @private
   */
  _setSaveFailed: function() {
    this.set('saveFailed', true);
  },

  /**
   * Convenience method for promises that want to mark the saving process as successful.
   * @method _setSaveSuccess
   * @private
   */
  _setSaveSuccess: function() {
    this.set('saveSuccess', true);
  },

  /**
   * @method _navigateToNextStep
   * @private
   */
  _navigateToNextStep: function() {
    this._getWizardWidget().navigateToNextStep();
  },

  /**
   * Get the decline text for a specific form name, if not found return the generic decline text
   * @method _getDeclineText
   * @private
   */
  _getDeclineText: function() {
    var lowerCaseFormName = stringUtils.nullSafeTrimAllLowerCase(this.formName);
    var declineFormMessageKey = stringUtils.nullSafeReplaceAllSpacesByDot(lowerCaseFormName) + '.declined.description';
    if ($.i18n.map[declineFormMessageKey]) {
      return $.i18n.prop(declineFormMessageKey, this.formName);
    }
    return $.i18n.prop('appointmentForm.decline.modal.body', this.formName);
  }
});
